import * as React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import styles from './videoElement.css';

const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;

  width: 75px;
  height: 75px;
  padding: 0;
  padding: 0;

  background-color: transparent;
  background-image: url(${require('sources/playIcon.png')});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: none;
  outline: none;
  transform: translate(-50%, -50%);
  cursor: pointer;
  visibility: ${({ active }) => (active ? 'hidden' : 'visible')}
  transition: opacity 0.2s ease;

  @media (min-width: 1280px) {
    width: 200px;
    height: 200px;

    background-image: url(${require('sources/playIcon.png')});
  }
`;

class VideoElement extends React.Component {
  constructor(props) {
    super(props);

    this.videoElement = React.createRef();
  }

  state = { active: false };

  onVideoClick = () => {
    const { active } = this.state;
    if (active) {
      this.setState(
        () => ({ active: false }),
        () => {
          this.videoElement.current && this.videoElement.current.pause();
        },
      );
    }
  };
  playVideo = () => {
    this.setState(
      () => ({ active: true }),
      () => {
        this.videoElement.current && this.videoElement.current.play();
      },
    );
  };

  render() {
    const { src, poster, className } = this.props;
    const { active } = this.state;
    return (
      <div className={className}>
        <PlayButton
          onClick={this.playVideo}
          hidden={active}
          title="Воспроизвести видео"
        />
        <video
          controls={active}
          className={cx(styles.video, className)}
          onClick={this.onVideoClick}
          ref={this.videoElement}
          src={src}
          poster={poster}
        />
      </div>
    );
  }
}

export default VideoElement;



// WEBPACK FOOTER //
// ./src/components/modules/SliderDesktopSection/VideoElement.js